module.exports = __webpack_public_path__ + "img/frame (52).581dd1c3.jpg";